import '../../../../../styles.scss';
import React, { useEffect, useRef, useState } from 'react';
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import SniffToast, { toasterDanger } from '../../utils/sniff-toast';
import { ASSET_PATH } from '../../../../consts/env.consts';
import useMutateTrackEvent from '../../../../services/hooks/useMutateTrackEvent';
import { setFirstClick } from '../../../../helpers/firstClick';
import useMobileScreen from '../../hooks/useMobileScreen';
import HomeSSR from '../../../../pages/home/home-ssr';
import { loadFirebaseAfterPageLoad } from '../../../../helpers/load-firebase';

// eslint-disable-next-line no-undef
__webpack_public_path__ = ASSET_PATH;

const client = new ApolloClient({
    link: new HttpLink({ uri: '/graphql' }),
    cache: new InMemoryCache(),
});

const Home = (props) => {
    const isMobileSSR = useMobileScreen();

    useEffect(() => {
        setFirstClick();
        loadFirebaseAfterPageLoad();
    }, []);

    return (
        <ApolloProvider client={client}>
            <SniffToast />
            <HomeSSR
                {...{
                    ...props,
                    isMobileSSR,
                    useStateSSR: useState,
                    useEffectSSR: useEffect,
                    useRefSSR: useRef,
                    useMutateTrackEvent,
                    toasterDanger,
                }}
            />
        </ApolloProvider>
    );
};

export default Home;
